import { Modal, Button } from "antd";
import React from "react";
import LoaderTsx from "../../modules/Loader.tsx";

const PdfView = (props) => {
  const { openFileView, setOpenFileView, previewFile, pdfData, setSendSettlementReport, onClick, isLoading, closable } =
    props;

  const onCloseModal = () => {
    setSendSettlementReport && setSendSettlementReport(false);
    setOpenFileView(false);
  };

  return (
    <Modal
      open={openFileView}
      onCancel={() => onCloseModal()}
      cancelText="Close"
      okButtonProps={{ style: { display: "none" } }}
      closable={closable}
      cancelButtonProps={{ style: { position: "absolute", top: "44px", left: "44px" } }}
      style={{ top: 20 }}
      width={"80%"}
      className="pdf-width"
    >
      {!isLoading ? (
        <div>
          {openFileView?.docType === "settlmentReport" && (
            <div style={{ position: "relative", left: "800px" }}>
              <Button onClick={() => onClick()} className={"ef-approve-btn"} type="primary">
                sent to tenant
              </Button>
            </div>
          )}
          <div style={{ marginTop: 50 }}>
            {!previewFile && pdfData && (
              <>
                <embed src={pdfData} title="" width="100%" height="2100px" />
              </>
            )}
            {previewFile && (
              <>
                <embed src={previewFile} title="" width="100%" height="2100px" />
              </>
            )}
          </div>
        </div>
      ) : (
        <LoaderTsx />
      )}
    </Modal>
  );
};
export default React?.memo(PdfView);
